export var TermsAndConditions = function(termsAndConditionsData) {
    var termsAndConditions = {};
    
    // Constructor
    if (termsAndConditionsData) {
        termsAndConditions.version = termsAndConditionsData.version;
        termsAndConditions.acceptedDate = termsAndConditionsData.acceptedDate;
        termsAndConditions.valid = termsAndConditionsData.valid;
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------
    
    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------
    
    return termsAndConditions;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/termsAndConditions.js
// module id = 36
// module chunks = 0